import React, { useEffect, useState } from "react";
import "scss/manage-users.scss";
import "scss/reports-page.scss";
import TransactionsTable from "widgets/TransactionsTable.widget";
import "react-toastify/dist/ReactToastify.css";
import useGetReportsList from "hooks/transaction/useGetReportsList.hook";
import useGetReconciliationsReportsList from "hooks/reconciliation/useGetReconciliationReportsList.hook";

import { useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "state";
import paths from "paths";

export interface Transaction {
  id: string | null;
  currentMonth: boolean;
  month: string;
  year: number;
  status: string;
  created_at: string;
}

export const ReportsPage: React.FC = () => {
  const { id } = useParams();
  const state = useStateContext();
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    if (!state.user?.roles || state.user.roles.length === 0) {
      navigate(paths.authenticated.DASHBOARD);
    } else {
      setIsAuthorized(true);
    }
  }, [state.user, navigate]);

  const account = id || state.user?.roles[0].accountNumber.toString();

  const [transactionType, setTransactionType] = useState<string>("all");
  const { data: reconciliationData, isLoading: isLoadingReconciliations } =
    useGetReconciliationsReportsList("reconciliations", account!);

  const { data: reportsData, isLoading: isLoadingReports } = useGetReportsList(
    transactionType,
    account!,
  );

  // Select active data and loading indicator based on transactionType
  const transactions =
    transactionType === "reconciliations" ? reconciliationData : reportsData;
  const isLoading =
    transactionType === "reconciliations"
      ? isLoadingReconciliations
      : isLoadingReports;

  const [localTransactions, setLocalTransactions] = useState<Transaction[]>(
    transactions ?? [],
  );

  useEffect(() => {
    if (transactions) {
      setLocalTransactions(transactions);
    }
  }, [transactions]);

  if (!isAuthorized) {
    return null;
  }

  return (
    <div className="reports-layout">
      <div className="manageUsers_wrapper manageUser_table_wrapper">
        <div className="header-section">
          <h1>Monthly Transactions</h1>
          <p>All dates are based on UTC.</p>
        </div>

        <div className="header-section-right">
          Type:
          <select
            className="transaction-type-dropdown"
            value={transactionType}
            onChange={(event) => setTransactionType(event.target.value)}
          >
            <option value="all">All Transactions</option>
            <option value="completes">Completes</option>
            <option value="reconciliations">Reconciliations</option>
          </select>
        </div>

        <TransactionsTable
          transactions={localTransactions}
          setTransactions={setLocalTransactions}
          reportType={transactionType}
          isTableLoading={isLoading}
          accountId={account!}
        />
      </div>
    </div>
  );
};

export default ReportsPage;
